// Mobile Menu Horizontal Animation avec GSAP
document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth >= 768) return; // Desktop uniquement
  
  // Load GSAP if not already loaded
  if (typeof gsap === 'undefined') {
    const script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
    script.onload = initMobileMenu;
    document.head.appendChild(script);
  } else {
    initMobileMenu();
  }
});

function initMobileMenu() {
  const menuDrawer = document.querySelector('[data-modal="leftDrawer"]');
  if (!menuDrawer) return;

  // Observer pour détecter quand le menu s'ouvre/ferme
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === 'style' || mutation.attributeName === 'x-show') {
        const isOpen = Alpine.store('modals').leftDrawer.open;
        
        if (isOpen) {
          gsap.fromTo(menuDrawer, 
            { 
              y: '-100%',
              opacity: 0
            },
            { 
              y: '0%',
              opacity: 1,
              duration: 0.5,
              ease: 'power3.out'
            }
          );

          // Animation des items de menu en cascade
          const menuItems = menuDrawer.querySelectorAll('ul > li');
          gsap.fromTo(menuItems,
            {
              x: -50,
              opacity: 0
            },
            {
              x: 0,
              opacity: 1,
              duration: 0.4,
              stagger: 0.05,
              ease: 'power2.out',
              delay: 0.2
            }
          );
        } else {
          gsap.to(menuDrawer, {
            y: '-100%',
            opacity: 0,
            duration: 0.4,
            ease: 'power3.in'
          });
        }
      }
    });
  });

  observer.observe(menuDrawer, {
    attributes: true,
    attributeFilter: ['style', 'x-show']
  });

  // Animation des sous-menus
  document.addEventListener('click', (e) => {
    const expandButton = e.target.closest('[data-modal="leftDrawer"] button[aria-expanded]');
    if (!expandButton) return;

    const isExpanded = expandButton.getAttribute('aria-expanded') === 'true';
    const submenu = expandButton.nextElementSibling;
    
    if (submenu && submenu.hasAttribute('x-collapse')) {
      setTimeout(() => {
        const items = submenu.querySelectorAll('li');
        if (!isExpanded) {
          gsap.fromTo(items,
            {
              x: -20,
              opacity: 0
            },
            {
              x: 0,
              opacity: 1,
              duration: 0.3,
              stagger: 0.03,
              ease: 'power2.out'
            }
          );
        }
      }, 50);
    }
  });
}
